<template>
    <div>
        <Header></Header>

        <div class="page">
            <div class="block" v-if="stage == 2">
                <p>We're sorry that Journo Portfolio didn't suit your needs. We appreciate any feedback.</p>

                <p>The main reason I want to delete my portfolio is:</p>
                <ul class="delete-ul">
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'no longer needed' }"
                      @click="delete_option = 'no longer needed'"
                    ></div>
                    <span>I just don't need a portfolio any more</span>
                  </li>
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'found better alternative' }"
                      @click="delete_option = 'found better alternative'"
                    ></div>
                    <span>I found a better alternative</span>
                    <p v-if="delete_option == 'found better alternative'" class="delete-alert">
                      <span>The alternative:</span>
                      <input v-model="delete_text" type="text" />
                      <span class="errorlist" v-if="errors&&errors.delete_text">{{errors.delete_text[0] }}</span>
                    </p>
                  </li>
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'pricing' }"
                      @click="delete_option = 'pricing'"
                    ></div>
                    <span>I can't afford or don't want to pay</span>
                  </li>
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'missing feature' }"
                      @click="delete_option = 'missing feature'"
                    ></div>
                    <span>It didn't have a feature I need</span>
                    <p v-if="delete_option == 'missing feature'" class="delete-alert">
                      <span>The missing feature(s):</span>
                      <input v-model="delete_text" type="text" />
                      <span class="errorlist" v-if="errors&&errors.delete_text">{{errors.delete_text[0] }}</span>
                    </p>
                  </li>
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'bugs' }"
                      @click="delete_option = 'bugs'"
                    ></div>
                    <span>Something was broken or buggy</span>
                    <p v-if="delete_option == 'bugs'" class="delete-alert">
                      <span >Can you tell us what wasn't working?</span>
                      <input v-model="delete_text" type="text" />
                      <span class="errorlist" v-if="errors&&errors.delete_text">{{errors.delete_text[0] }}</span>
                    </p>
                  </li>
                  <li>
                    <div
                      class="checkbox-div"
                      :class="{ checked: delete_option == 'other' }"
                      @click="delete_option = 'other'"
                    ></div>
                    <span>Other</span>
                    <p v-if="delete_option == 'other'" class="delete-alert">
                      <span>What makes you want to delete your portfolio?</span>
                      <input v-model="delete_text" type="text" />
                      <span class="errorlist" v-if="errors&&errors.delete_text">{{errors.delete_text[0] }}</span>
                    </p>
                  </li>
                </ul>
                <div v-if="show_error" class="errorlistlisttop" >
                  Do you mind indicating a reason? It really helps us to keep improving the system
                </div>
                <button @click="save()">
                  <span>Permanantly delete my portfolio</span>
                </button>
              </div>
              <div class="block" v-if="stage == 1">
                <div class="alert">
                  <p><strong >By deleting your portfolio you understand:</strong>
                      <ul>
                  <li>
                    If this is your ownly portfolio, your account will also be deleted.
                  </li>
                  <li>
                    All of your articles, pages and other data will be irretrievably deleted.
                  </li>
                  <li>
                    Your URL will immediately stop working, so anybody visiting your portfolio will see an error page.'
                  </li>
                  <li
                    v-if="portfolio.account_type == 'pro' || portfolio.account_type == 'unlimited'"
                   >
                    You will lose access to all of your backups.
                  </li>
                  <li
                    v-if="portfolio.account_type == 'pro' || portfolio.account_type == 'unlimited'">
                    Your domain will no longer be renewed and could be registered by somebody else.
                  </li>
                </ul>
                  </p>
                </div>

                <div class="alert">
                  <p><strong>You do not need to delete your portfolio to:</strong>
                      <ul><li>Chnage your portfolio name, email or URL.</li>
                        <li>If you just want to temporarily unpublish your portfolio.</li></ul>
                  </p>
                </div>


                <b v-if="portfolio.account_type!='free'&&!portfolio.subscription_is_cancelled" v-t="'You must first switch to the free plan to delete your portfolio.'"></b>
                <div class="buttons">
                    <router-link class="button" v-if="portfolio.account_type=='free'||portfolio.subscription_is_cancelled" :to="{name: 'account'}" v-t="'Don\'t Delete'"></router-link>&nbsp;
                    <button v-if="portfolio.account_type=='free'||portfolio.subscription_is_cancelled" @click="nextStage()" v-t="'I Understand, Delete Portfolio'"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header
        },
        data () {
            return {
                saving: false,
                stage: 1,
                errors: {},
                show_error: false,
                delete_option: null,
                delete_text: '',
            }
        },
        computed: {
            user () {
                return this.$store.getters['auth/user']
            },
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            },
        },
        methods: {
            nextStage () {
                this.stage += 1
            },
            nextStage2 () {
                if (this.user) {
                    if(this.delete_option === null || typeof(this.delete_option) === "undefined"){
                        this.show_error = true;
                    }else{
                        this.stage = 4;
                    }
                }
            },
            save () {
                this.saving = true
                this.$http.put('/user/delete/', {
                    delete_text: this.delete_text,
                    delete_option: this.delete_option,
                }).then(data => {
                    if(data.data.deleted_user){
                          this.$store.dispatch('messages/success', this.$t('messages.account-deleted'))
                          window.location = 'https://www.journoportfolio.com/logout/?delete=1';
                    }else{
                      this.$store.dispatch('messages/success', this.$t('Portfolio Deleted'))
                      window.location = 'https://www.journoportfolio.com/sites/'
                    }
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            }
        },
        mounted () {
        }
    }
</script>

